import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  Typography,
  Box,
  Button,
  styled,
  useTheme,
  CircularProgress,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: 20,
    padding: theme.spacing(3),
    maxWidth: '90%',
    margin: theme.spacing(2),
    background: theme.palette.background.paper,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 400,
      padding: theme.spacing(4),
    },
  },
}));

const StatusHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: theme.spacing(3),
}));

const StatusIconWrapper = styled(Box)(({ theme }) => ({
  width: 64,
  height: 64,
  borderRadius: '50%',
  backgroundColor: theme.palette.warning.lighter || theme.palette.warning.light,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

const AccessRestrictedBanner = ({ logout }) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(false);

  const handleSignOut = async () => {
    try {
      setLoading(true);
      await logout();
    } catch (error) {
      console.error('Error signing out:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <StyledDialog
      open
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      onClose={() => {}}
    >
      <DialogContent sx={{ p: 0, textAlign: 'center' }}>
        <StatusHeader>
          <StatusIconWrapper>
            <LockOutlinedIcon sx={{ fontSize: 32, color: 'warning.dark' }} />
          </StatusIconWrapper>
          <Typography variant="h6" align="center" sx={{ fontWeight: 600, mb: 1 }}>
            Access Restricted
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            Sorry, your access has been restricted. Please contact the center manager to learn more.
          </Typography>
        </StatusHeader>

        <ButtonContainer>
          <Button
            fullWidth
            variant="outlined"
            color="inherit"
            onClick={handleSignOut}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
            sx={{
              borderRadius: 2,
              py: 1.5,
              textTransform: 'none',
              color: 'text.secondary',
              borderColor: 'grey.300',
              '&:hover': {
                borderColor: 'grey.400',
              },
            }}
          >
            {loading ? 'Signing out...' : 'Sign Out'}
          </Button>
        </ButtonContainer>
      </DialogContent>
    </StyledDialog>
  );
};

export default AccessRestrictedBanner;
